import { render, staticRenderFns } from "./ScmInboundByCenter.vue?vue&type=template&id=1255ad82&scoped=true"
import script from "./ScmInboundByCenter.vue?vue&type=script&lang=js"
export * from "./ScmInboundByCenter.vue?vue&type=script&lang=js"
import style0 from "./ScmInboundByCenter.vue?vue&type=style&index=0&id=1255ad82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1255ad82",
  null
  
)

export default component.exports